import React, { useState } from "react";

function SupplierMaster() {
  const [supplier, setSupplier] = useState({
    supplierId: "SUP-" + Date.now(), // Auto-generated
    supplierName: "",
    contactPerson: "",
    phoneNumber: "",
    email: "",
    address: "",
    gstId: "",
    licenseNumber: "",
    bankDetails: "",
    status: "Active",
    rating: "",
    medicineId: "",
    medicineName: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSupplier({ ...supplier, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Supplier Saved:", supplier);
    alert("Supplier saved successfully!");
  };

  const styles = {
  container: {
    padding: "20px",
    background: "#f9fafb",
    borderRadius: "12px",
    margin: "20px auto",
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    width:'95%'
  },
  row: {
    display: "flex",
    gap: "16px",
    marginBottom: "16px",
    flexWrap: "wrap",
  },
  formGroup: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  label: {
    marginBottom: "4px",
    fontSize: "13px",
    fontWeight: "600",
    color: "#374151",
  },
  input: {
    padding: "8px 12px",
    borderRadius: "6px",
    border: "1.5px solid #d1d5db",
    fontSize: "13px",
    background: "#fff",
    transition: "all 0.2s ease",
  },
  button: {
    marginTop: "16px",
    padding: "10px 20px",
    background: "linear-gradient(90deg, #16a34a, #15803d)",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    boxShadow: "0 4px 10px rgba(22,163,74,0.3)",
  },
};

  return (
    <div style={styles.container}>
      <h2 style={{ fontSize: "22px", marginBottom: "20px", fontWeight: "700", color: "#111827" }}>
       Add Distributor
      </h2>

      <form onSubmit={handleSubmit}>
        {/* Row 1 */}
        <div style={styles.row}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Medicine ID</label>
            <input
              type="text"
              name="medicineId"
              value={supplier.medicineId}
              style={styles.input}
              placeholder="Enter unique medicine ID (e.g., MED-101)"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Medicine Name</label>
            <input
              type="text"
              name="medicineName"
              value={supplier.medicineName}
              style={styles.input}
              placeholder="Enter medicine name (e.g., Paracetamol)"
            />
          </div>
        </div>

        {/* Row 2 */}
        <div style={styles.row}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Supplier ID</label>
            <input
              type="text"
              name="supplierId"
              value={supplier.supplierId}
              readOnly
              style={{ ...styles.input, background: "#f3f4f6", cursor: "not-allowed" }}
              placeholder="Auto-generated"
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Supplier Name</label>
            <input
              type="text"
              name="supplierName"
              value={supplier.supplierName}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter supplier name"
              required
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Contact Person</label>
            <input
              type="text"
              name="contactPerson"
              value={supplier.contactPerson}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter contact person name"
            />
          </div>
        </div>

        {/* Row 3 */}
        <div style={styles.row}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Phone Number</label>
            <input
              type="text"
              name="phoneNumber"
              value={supplier.phoneNumber}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter phone number"
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Email Address</label>
            <input
              type="email"
              name="email"
              value={supplier.email}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter email (e.g., supplier@mail.com)"
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>GST / Tax ID</label>
            <input
              type="text"
              name="gstId"
              value={supplier.gstId}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter GST number"
            />
          </div>
        </div>

        {/* Row 4 */}
        <div style={styles.row}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Bank Details / Payment Terms</label>
            <input
              type="text"
              name="bankDetails"
              value={supplier.bankDetails}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter bank account details or UPI ID"
            />
          </div>
        </div>

        {/* Row 5 */}
        <div style={styles.row}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Status</label>
            <select
              name="status"
              value={supplier.status}
              onChange={handleChange}
              style={styles.input}
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
        </div>

        <div>
          <button type="submit" style={styles.button}>
             Save Supplier
          </button>
        </div>
      </form>
    </div>
  );
}

export default SupplierMaster;
